import { Option } from '@/common/types/option'

export const stateOptions: Option[] = [
  { value: 'registered', label: 'Cadastrou a empresa' },
  { value: 'qualifying', label: 'Iniciou Qualificação' },
  { value: 'qualifying_management_review', label: 'Enviou para análise do gestor' },
  { value: 'qualifying_approved', label: 'Enviou para Certame' },
  { value: 'in_bidding', label: 'Aguardando resultado' },
  { value: 'contracting', label: 'Iniciou contratação' },
  { value: 'contracting_management_review', label: 'Enviou para análise' },
  { value: 'contracting_finalization', label: 'Aguardando implantação' },
]
